import { type ConsentType, type CustomerConsent } from "@repo/api";

export const changeManualConsent = (
  value: boolean,
  consentType: ConsentType,
  manualConsents?: CustomerConsent[],
  consentFromApi?: CustomerConsent
) => {
  const consentInList = manualConsents?.find(
    (consent) => consent.consentType === consentType
  );

  // not in the list
  if (!consentInList) {
    return [
      ...(manualConsents ?? []),
      { ...(consentFromApi ?? { consentType }), consentProvided: value },
    ];
  } else {
    return (
      manualConsents?.map((consent) =>
        consent.consentType === consentType
          ? { ...consent, consentProvided: value }
          : consent
      ) ?? []
    );
  }
};
